import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecadb370"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md-input-wrapper" }
const _hoisted_2 = ["value", "placeholder"]
const _hoisted_3 = ["value", "placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "error", -1))
const _hoisted_6 = {
  key: 1,
  class: "error-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_menu = _resolveComponent("md-menu")!
  const _component_transition_md_menu = _resolveComponent("transition-md-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["md-input md-select md-input-field", [
        _ctx.variant,
        _ctx.size,
        _ctx.icon ? 'icon' : '',
        _ctx.hasValue ? 'has-value' : '',
        _ctx.errorMessage ? 'has-error' : '',
      ]])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["label", { icon: _ctx.icon }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focusIn && _ctx.focusIn(...args)))
      }, _toDisplayString(_ctx.label), 3),
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "icon material-icons-outlined",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusIn && _ctx.focusIn(...args)))
          }, _toDisplayString(_ctx.icon), 1))
        : _createCommentVNode("", true),
      (!_ctx.searchable)
        ? (_openBlock(), _createElementBlock("input", _mergeProps({
            key: 1,
            type: "text",
            readonly: "",
            value: _ctx.title
          }, { required: _ctx.required, disabled: _ctx.disabled }, {
            onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            ref: "input",
            placeholder: _ctx.placeholderValue
          }), null, 16, _hoisted_2))
        : (_openBlock(), _createElementBlock("input", _mergeProps({
            key: 2,
            type: "text",
            value: _ctx.title
          }, { required: _ctx.required, disabled: _ctx.disabled }, {
            onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            ref: "input",
            placeholder: _ctx.placeholderValue,
            onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetValues && _ctx.resetValues(...args))),
            onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }), null, 16, _hoisted_3)),
      (_ctx.variant === 'filled')
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(["bottom-line", [_ctx.hasValue || _ctx.focused ? 'active' : '']])
          }, null, 2))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_transition_md_menu, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_md_menu, {
          items: _ctx.searchable ? _ctx.results : _ctx.items,
          "icon-space": !!_ctx.icon,
          onSelect: _ctx.onChange,
          value: _ctx.modelValue,
          small: ""
        }, null, 8, ["items", "icon-space", "onSelect", "value"]), [
          [_vShow, _ctx.menuVisible]
        ])
      ]),
      _: 1
    }),
    (_ctx.errorMessage || _ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage || _ctx.error), 1)
        ]))
      : (_ctx.error !== false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : _createCommentVNode("", true)
  ]))
}